/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
} from 'react'

import { Helmet } from "react-helmet";
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import _ from "lodash";

import { useNavigate } from 'react-router-dom';

import LoadingContent from 'app/modules/loading/LoadingContent';
import PurchaseMenu from 'app/utils/PurchaseMenu';

import {
  fetchSignatures,
} from 'app/services/signatures';

import {
  formatLongDate,
  formatLongDateToDate,
} from 'app/services/dates';
import { formatMoney } from 'app/services/intFormat';

const SignatureList = () => {
  const { signatures, auth } = useSelector((state : any) => ({
    signatures: state.signatures,
    auth: state.auth,
  }), shallowEqual);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [list, setList] = useState<any>([]);
  const [activeList, setActiveList] = useState<any>([]);

  const getPeriod = (value) => {
    if (value === 1) {
      return 'mês';
    }

    return `a cada ${value} meses`;
  }

  useEffect(() => {
    dispatch<any>(fetchSignatures()).then((response: any) => {
      setList(response.filter((value: any) =>
        value.relationships.status.attributes.name !== 'active' && value.relationships.status.attributes.name !== 'pending')
      );

      setActiveList(response.filter((value: any) =>
        value.relationships.status.attributes.name === 'active' || value.relationships.status.attributes.name === 'pending')
      );
    });
  }, []);

  useEffect(() => {
    if(!auth.user) {
      navigate('/')
    }
  }, [auth]);

  const showItem = (item: any) => {
    return <div className="col-lg-6 mb-1 mb-lg-0">
      <div className="d-flex justify-content-center">
        <div
          className="card card-dashed flex-row flex-stack p-4 mb-6 w-100 cursor-pointer"
          onClick={() => navigate(`/assinaturas/clubinho/${item.id}`)}
        >
          <div className="d-flex align-items-center me-2">
            <div className="flex-grow-1">
              <div className="d-flex align-items-center fs-2 fw-bold flex-wrap pb-2">{item?.relationships?.plan?.attributes?.name}</div>
              <div className="fs-7 fw-semibold text-gray-700 pb-1">{item?.relationships?.plan?.relationships?.branches?.[0].attributes?.name}</div>
              <div className="fs-7 fw-semibold text-gray-700 pb-1">
                {item.relationships.status.attributes.name === 'active' && item.attributes.auto_renew && 'renovação em '}
                {item.relationships.status.attributes.name !== 'active' && item.attributes.auto_renew && 'válido até '}
                {!item.attributes.auto_renew && 'válido até '}
                {formatLongDateToDate(item.attributes.finish_at, true)}
              </div>
              <div className="fs-7 fw-semibold text-gray-900 pb-1">
                {formatMoney(item.attributes.price)} / {getPeriod(item.relationships.plan.attributes.duration)}
              </div>
            </div>
          </div>
          <div className="d-flex ms-5">
            <div className="flex-grow-1 text-uppercase">
              {(item?.relationships?.status?.attributes?.name === 'pending') && <span className="flex d-flex text-warning fs-6 fw-bold text-center">
                Pendente
              </span>}

              {(item?.relationships?.status?.attributes?.name === 'active') && <span className="flex d-flex text-primary fs-6 fw-bold text-center">
                Ativo
              </span>}

              {(item?.relationships?.status?.attributes?.name === 'canceled') && <span className="flex d-flex text-gray-700 fs-6 fw-bold text-center">
                Cancelado
              </span>}

              {(item?.relationships?.status?.attributes?.name === 'expired') && <span className="flex d-flex text-gray-700 fs-6 fw-bold text-center">
                Expirado
              </span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  return (<>
    <Helmet>
      <title>Minhas assinaturas - Clubinho - Atacante App</title>
    </Helmet>

    <PurchaseMenu recurrence />

    {<div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0 mb-13'>
        {activeList.length > 0 && <div className='mb-10'>
          <div className="mb-10">
            <h1 className="mb-3">
              Clubinho que você participa
            </h1>
          </div>
          <div className="row mt-10">
            {activeList.map(item => {
              return showItem(item)
            })}
          </div>
        </div>}

        {list.length > 0 && <>
          <div className="mb-10">
            <h1 className="mb-3">
              Histórico de clubinho
            </h1>
          </div>
          <div className="row mt-10">
            {list.map(item => {
              return showItem(item)
            })}
          </div>
        </>}

        {signatures.listLoading === false && list.length === 0 && activeList.length === 0 && <div className="my-10 text-center">
          <h2 className="mb-3">
            Você não efetuou nenhuma compra
          </h2>
          <div className="text-muted fw-semibold fs-5">
            Garanta descontos exclusivos para jogar com seus amigos!
          </div>
        </div>}

        {signatures.listLoading === true && list.length === 0 && <LoadingContent />}
      </div>
    </div>}
  </>)
}

export {
  SignatureList
}
